<div [formGroup]="uploadToDocBoxForm">
    <div class="row">
        <label
            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_UPLOAD_TO_DOCBOX_LABEL"
        ></label>
        <div class="col-12 col-lg-auto mb-3">
            <pace-core-radio-input
                [(model)]="model.uploadToDocBoxOptions"
                [parentForm]="uploadToDocBoxFormChildren"
                id="radioDocBoxOptions"
                (valueChange)="onOptionChange()"
            ></pace-core-radio-input>
        </div>
        <div class="col-auto">
            @if (model.documentTitle.length > 0) {
                <button
                    class="btn btn-primary"
                    translate="CONFIRMATION_UPLOAD_TO_DOCBOX_ADD_LABEL"
                    (click)="uploadFile()"
                ></button>
            }
        </div>
    </div>
    @if (model.documentTitle.length > 0) {
        <div class="row mb-3">
            <label class="col-2 col-form-label"></label>
            <div class="col-8">
                <strong>{{ 'CONFIRMATION_UPLOADED_TO_DOCBOX_LABEL' | translate }}</strong>
                @for (docTitle of model.documentTitle; track docTitle) {
                    <div>{{ docTitle }}</div>
                }
            </div>
        </div>
    }
</div>
